/* WL: the product photo column (assets/wl-pd-gallery.css).
 * Scroll pill: the column has no scrollbar; this small floating pill shows how far down the photos you are. Only shown
 * when the photos don't all fit.
 * Wheel: the column scrolls itself while the pointer is over it, one photo per step, so the browser never starts its
 * own scroll gesture there. Browsers keep a scroll gesture "latched" to where it began, so with native scrolling, moving off the
 * column mid-scroll kept scrolling the column instead of the page. At either end of the column the wheel is left to
 * the browser, so the page carries on. */
(function () {
  const desktop = matchMedia('(min-width: 990px)');
  document.querySelectorAll('media-gallery[data-desktop-layout="thumbnail"]').forEach(g => {
    const list = g.querySelector('.thumbnail-list');
    if (!list || list.children.length < 2) return;

    const bar = document.createElement('div');
    bar.className = 'wl-rail-bar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<i><b></b></i>';
    list.parentElement.appendChild(bar);
    const knob = bar.querySelector('b');
    const update = () => {
      const { scrollTop: top, scrollHeight: full, clientHeight: seen } = list;
      bar.hidden = full <= seen + 2;
      if (bar.hidden) return;
      const size = Math.max(seen / full * 100, 22);
      knob.style.height = size + '%';
      knob.style.top = (top / (full - seen)) * (100 - size) + '%';
    };
    list.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
    update();

    // One photo per step, as Pro:Direct: the column slides from photo to photo, never stopping part-way. Wheel input is
    // measured by distance, whatever the device: the first input of a movement steps at once, then every further
    // 100px is one more photo (a mouse notch is ~100px; high-resolution wheels and Windows smooth scrolling send the
    // same distance as a stream of small events). Steps that build up during a slide queue (up to 3), so continuous
    // scrolling keeps moving photo by photo; reversing direction drops the queue.
    const STEP = 100;
    const max = () => list.scrollHeight - list.clientHeight;
    const tops = () => [...list.children].map(li => Math.min(li.offsetTop - list.offsetTop, max()));
    let sliding = false, pending = 0, dirNow = 0, acc = 0, lastWheel = 0, slideTarget = null;
    function nextStop(from, dir) {
      const stops = [...new Set(tops())].sort((x, y) => x - y);
      return dir > 0 ? stops.find(v => v > from + 2) : [...stops].reverse().find(v => v < from - 2);
    }
    function stepOnce() {
      const next = nextStop(list.scrollTop, dirNow);
      if (next === undefined) { pending = 0; return; }
      slideTo(Math.max(0, Math.min(max(), next)));
    }
    function slideTo(to) {
      const from = list.scrollTop, start = performance.now(), ms = 240;
      sliding = true; slideTarget = to;
      const tick = now => {
        const t = Math.min(1, (now - start) / ms), ease = 1 - Math.pow(1 - t, 3);
        list.scrollTop = from + (to - from) * ease;
        if (t < 1) return requestAnimationFrame(tick);
        sliding = false; slideTarget = null;
        if (pending > 0) { pending--; stepOnce(); }
      };
      requestAnimationFrame(tick);
    }
    list.addEventListener('wheel', e => {
      if (!desktop.matches || e.ctrlKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      // Only while the column is in view from its top. Once the page has scrolled past the gallery (coming back up
      // from the description, or carrying on down), the wheel is the page's: the column never holds it up.
      if (list.getBoundingClientRect().top < -10) { pending = 0; acc = 0; return; }
      const dy = e.deltaY * (e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? list.clientHeight : 1);
      if (!dy) return;
      const now = performance.now(), dir = Math.sign(dy), fresh = now - lastWheel > 150;
      lastWheel = now;
      // At an end (and nothing still sliding or queued that way): let the page scroll.
      const pos = slideTarget === null ? list.scrollTop : slideTarget;
      if (!pending && ((dir < 0 && pos <= 0) || (dir > 0 && pos >= max() - 1))) { acc = 0; return; }
      e.preventDefault();
      if (dir !== dirNow) { dirNow = dir; pending = 0; acc = 0; fresh || (acc = 0); }
      if (fresh && !sliding) { acc = 0; stepOnce(); return; }
      acc += Math.abs(dy);
      while (acc >= STEP) { acc -= STEP; if (sliding || pending) pending = Math.min(3, pending + 1); else stepOnce(); }
    }, { passive: false });
  });
})();
